define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/view/ToolbarPluginSwitchboard"
], function(declare,lang,csi,ToolbarPluginSwitchboard) {

	return declare(ToolbarPluginSwitchboard, {
		idViewProperty: "dependsOnValue",
		placeHolder: "SelectOne",
		refreshStoreOptions: true,
		resDefault: "",
		switchboardPath: "Child:DependsOn/Child:Values",

		canShowPlugin: function() {
			// summary: only show if current enum depends on another
			return this._hasDependsOnEnum();
		},

		onChangeItem: function(/*csi.view.Widget*/view, /*Node*/node) {
			// summary: do nothing - idViewProperty handles it all
		},

		postCreate: function() {
			// summary: refresh the review store when the selected sizes (columns) changes
			var	self = this;

			this.inherited(arguments);

			this.getView().watch("urlRoot", function() {
				self.refreshStore(csi.EMPTY_URL);
			});
		},

		validatePlugin: function(/*Context*/ctx) {
			// summary: hide if printing
			return !ctx.bPrint;
		},

		_hasDependsOnEnum: function() {
			// summary: return true if current EnumList depends on another
			return !!this.getView().get("dependsOnEnum");
		},

		_getStoreOptions: function(/*String*/url, /*Relationship?*/r) {
			// summary: drop-down should show localized names
			if (!this._hasDependsOnEnum()) {
				return null;
			}

			var	options = this.inherited(arguments);
			var	view = this.getView();
			options.customOperation = false;
			options.onResultItem = lang.hitch(view, view.onDependsOnEnumValue);
			return options;
		}
	});
});